import {  ToastController } from '@ionic/angular';
import { Injectable } from "@angular/core";

@Injectable()
export class ToastComponent {
    isLoading = false;
    constructor( public toastController: ToastController) {

    }
    async showToast(message,type){
        const toast = await this.toastController.create({
            message: message,
            position: "top",
            duration: 2000,
            color: type,
            // cssClass: type==='success' ? 'success-toast' : 'error-toast'
          });
          toast.present();
    }

    async DeleteToast() {
        const toast = await this.toastController.create({
            message: "Delete Successfully",
            position: "top",
            duration: 2000,
            color: "success"
          });
          toast.present();
    }
    async FailToast() {
        const toast = await this.toastController.create({
            message: "try again",
            position: "top",
            duration: 2000,
            color: "danger"
          });
          toast.present();
    }
    async AlreadyReported() {
        const toast = await this.toastController.create({
            message: "You already reported this property",
            position: "top",
            duration: 2000,
            color: "danger"
          });
          toast.present();
    }
    async ActiveDeactiveToast (message) {
        const toast = await this.toastController.create({
            message: message,
            position: "top",
            duration: 2000,
            color: "success"
          });
          toast.present();
    }
}